import { Checkbox } from '@mui/material'
import { type ComponentProps, useCallback } from 'react'

const CheckboxWithValue = <T,>({
	onChange,
	value,
	...props
}: Omit<ComponentProps<typeof Checkbox>, 'onChange'> & {
	onChange: (event: React.ChangeEvent<HTMLInputElement>, value: T) => void
	value: T
}) => {
	const handleOnChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => onChange(event, value),
		[onChange, value]
	)
	return <Checkbox {...props} onChange={handleOnChange} />
}

export { CheckboxWithValue }
